// Product page (/product/:id): gallery, buy block, upsell, accessories,
// keepsake section and technical specs. Translation of fr/fiche.js — same keys.
// The PRODUCT texts (name, tagline, description, features) come from the
// database via the API: they go through tp()/tpList(), never through these keys.
// British English — also the international fallback for visitors outside the
// six shipping countries.
export default {
  'fiche.seo.titre': '{nom} — Joyful Reveal',
  'fiche.seo.descriptionDefaut':
    'The Joyful Reveal gender reveal game: a quiz in two teams, a puzzle to piece together and a final piece to scratch.',
  'fiche.seo.titreIntrouvable': 'Product not found',
  'fiche.seo.titreErreur': 'Loading error',
  'fiche.seo.descriptionErreur': 'This product is no longer available in the Mirum Games shop.',

  'fiche.chargement.produit': 'Loading the product…',

  'fiche.erreur.introuvableTitre': 'This pack no longer exists',
  'fiche.erreur.erreurTitre': 'Loading failed',
  'fiche.erreur.introuvableTexte':
    'It may have been replaced. You will find all our packs in the shop.',
  'fiche.erreur.erreurTexte': 'The connection to the server failed. Please try again in a moment.',
  'fiche.erreur.versBoutique': '🛍️ Go to the shop',

  'fiche.ariane.label': 'Breadcrumb',

  'fiche.visuels.boiteAlt':
    'Front of the Joyful Reveal box: two teddy bears and the puzzle piece to scratch',
  'fiche.visuels.boiteLegende': 'The box',
  'fiche.visuels.dosAlt':
    'Back of the box: the 4 steps of the game, the languages of the rules and the QR code',
  'fiche.visuels.dosLegende': 'The back of the box',
  'fiche.visuels.contenuAlt':
    'Contents of the Premium Pack: the box, the questionnaire and the two cotton pouches',
  'fiche.visuels.contenuLegende': 'What you receive',
  'fiche.visuels.pochonsAlt': 'The two cotton pouches handed to the two teams',
  'fiche.visuels.pochonsLegende': 'The team pouches',
  'fiche.visuels.grattageAlt': 'A hand scratches the puzzle’s golden panel with a coin: the word GIRL appears',
  'fiche.visuels.grattageLegende': 'The scratch',
  'fiche.visuels.puzzleEncadreAlt':
    'The assembled puzzle in a gold frame, standing on a piano between two candle holders',
  'fiche.visuels.puzzleEncadreLegende': 'The framed keepsake',
  'fiche.visuels.puzzleTableAlt':
    'The assembled puzzle in its gold frame, standing on an oak table',
  'fiche.visuels.puzzleTableLegende': 'After the party',
  'fiche.visuels.questionnaireAlt':
    'The quiz sheet printed on card, with its Team 1, Team 2 and Parents columns',
  'fiche.visuels.questionnaireLegende': 'The printed quiz sheet',
  'fiche.visuels.voir': 'View: {legende}',

  'fiche.achat.gamme': 'Joyful Reveal — Bears',
  'fiche.achat.promesse':
    'Eleven questions, two teams, one piece to scratch — and everyone finds out at the same time.',
  'fiche.achat.remise': '−{n}%',
  'fiche.achat.contenuTitre': 'What this pack contains',
  'fiche.achat.ajouter': '🛒 Add to basket',
  'fiche.achat.indisponible': 'Temporarily unavailable',
  'fiche.achat.reappro': 'New stock on its way',
  'fiche.achat.expedition': '📦 Shipped from Belgium within 1 to 2 working days',
  // Must stay in line with PAYS_LIVRES (frontend/src/lib/zonesLivraison.js).
  'fiche.achat.livraison':
    '🚚 Delivery to Belgium, France, Luxembourg, the Netherlands, Germany and Spain — postage calculated at checkout',
  'fiche.achat.langue':
    '🇫🇷 Box and rules in French (bilingual French / English summary on the box)',
  'fiche.achat.retour': '↩️ 14 days to change your mind',

  'fiche.genre.titre': 'It’s for…',
  'fiche.genre.fille': 'Girl',
  'fiche.genre.garcon': 'Boy',
  'fiche.genre.mixte': 'Girl + Boy',
  'fiche.genre.alerte': 'Please choose girl or boy first.',
  'fiche.genre.discretion':
    'Nobody but you will know: it is the scratch piece that announces it on the day.',
  'fiche.genre.packMixte': '👫 This pack contains BOTH the girl version and the boy version',
  'fiche.genre.packGarcon': '👦 Boy version',
  'fiche.genre.packFille': '👧 Girl version',

  // Sentence in 4 segments because two passages are bold in the JSX:
  // « For [X more], the [NAME] adds … » — the pack name sits between
  // phraseMilieu and phraseApres.
  'fiche.upsell.badge': '⭐ The most popular choice',
  'fiche.upsell.phraseAvant': 'For',
  'fiche.upsell.phraseGras': '{prix} more',
  'fiche.upsell.phraseMilieu': ', the',
  'fiche.upsell.phraseApres': 'adds all the extras that make the party special.',
  'fiche.upsell.voir': 'See the {nom} →',

  'fiche.caracteristiques.joueursLabel': 'Players',
  'fiche.caracteristiques.joueursValeur': '2 to 10',
  'fiche.caracteristiques.dureeLabel': 'Duration',
  'fiche.caracteristiques.dureeValeur': '≈ 20 minutes',
  'fiche.caracteristiques.piecesLabel': 'Pieces',
  'fiche.caracteristiques.piecesValeur': '11 + 1 to scratch',
  'fiche.caracteristiques.ageLabel': 'Age',
  'fiche.caracteristiques.ageValeur': 'From 3 years',

  'fiche.etapes.reglesLien': 'Read the full rules',
  'fiche.etapes.reglesSuite': '— the 11 questions are included, ready to print.',

  'fiche.accessoires.titreAvec': '🎁 Everything is already waiting in this pack',
  'fiche.accessoires.titreSans': '🎁 Want it all ready the moment you open the box?',
  'fiche.accessoires.introAvec':
    'You open the box, you put the questionnaire on the table, everyone takes their pouch — and the game begins.',
  'fiche.accessoires.introSans':
    'The Premium Pack adds the three extras that make the difference on the big day:',
  'fiche.accessoires.photoContenuAlt':
    'The contents of the Premium Pack laid out flat: the box, the printed questionnaire and the two team pouches',
  'fiche.accessoires.photoContenuLegende':
    'The printed questionnaire, the box and the pouches — real photo',
  'fiche.accessoires.photoPochonsAlt':
    'The two cotton drawstring pouches, labelled Team 1 and Team 2',
  'fiche.accessoires.photoPochonsLegende': 'The cotton team pouches — real photo',
  'fiche.accessoires.pochonsTitre': 'Two cotton pouches',
  'fiche.accessoires.pochonsTexte':
    'Labelled Team 1 and Team 2: everyone picks their side as they arrive, and the game starts by itself.',
  'fiche.accessoires.questionnaireTitre': 'The questionnaire, already printed',
  'fiche.accessoires.questionnaireTexte':
    'The 11 questions on 400 g card, with the score columns for both teams — plus a blank template for writing your own.',
  'fiche.accessoires.enveloppeTitre': 'The keepsake envelope',
  'fiche.accessoires.enveloppeTexte':
    'After the party the completed questionnaire slips inside — the envelope is designed to be fixed to the back of a picture frame.',
  'fiche.accessoires.decouvrir': 'Discover the {nom} →',

  'fiche.souvenir.photoAlt':
    'The finished puzzle, framed and hanging on a nursery wall',
  'fiche.souvenir.photoLegende':
    'The puzzle from the big day — 14 × 21 cm, the size of a picture frame',
  'fiche.souvenir.surtitre': 'And after the party?',
  'fiche.souvenir.titre': 'A picture stays on the wall',
  // Sentence cut around the bold « 14 × 21 cm » (the measurement is not translated).
  'fiche.souvenir.tailleAvant': 'The finished puzzle measures',
  'fiche.souvenir.tailleApres':
    '— exactly the size of an off-the-shelf picture frame. Many parents frame it and hang it in the baby’s room: the day everyone heard the news, in a single image.',
  // Sentence cut around the bold « the keepsake envelope ».
  'fiche.souvenir.premiumAvant':
    'The questionnaire in this pack is made for that: the winning team, who scratched the piece, the date — once it is filled in, slip it into',
  'fiche.souvenir.premiumEnveloppe': 'the keepsake envelope',
  'fiche.souvenir.premiumApres':
    ', fixed to the back of the frame. In ten years’ time, open it together.',
  'fiche.souvenir.upsell':
    'With the Premium Pack, the questionnaire you filled in on the big day (winning team, who scratched the piece, the date) slips into the keepsake envelope, on the back of the frame. In ten years’ time, open it together.',

  'fiche.specs.titre': '📋 Technical details',
  'fiche.specs.contenuLabel': 'Contents of the box',
  'fiche.specs.contenuValeur': '11 puzzle pieces to win + 1 unique piece to scratch',
  'fiche.specs.principeLabel': 'Principle',
  'fiche.specs.principeValeur':
    'Quiz in two teams, a puzzle to piece together, final reveal by scratching',
  'fiche.specs.reglesLabel': 'Rules',
  'fiche.specs.reglesValeur':
    'Summarised on the back of the box, full version online via the QR code',
  'fiche.specs.matiereLabel': 'Material',
  'fiche.specs.matiereValeur': 'Card — box and pieces',
  'fiche.specs.puzzleLabel': 'Assembled puzzle',
  'fiche.specs.puzzleValeur': '14 × 21 cm — the size of an off-the-shelf picture frame',
  'fiche.specs.securiteLabel': 'Safety',
  'fiche.specs.securiteValeur':
    'Compliant with CE / EN 71. Small parts: not suitable for children under 3 years',
  'fiche.specs.origineLabel': 'Origin',
  'fiche.specs.origineValeur': 'Designed and shipped from Belgium by Mirum Games',
};
